import { Box, Container, Typography, Link, Grid, useTheme, alpha } from '@mui/material';
import primaryLogo from '../images/BrightFuturePower.png';
import iconLogo from '../images/BrightFuturePower ICON.png';

const Footer = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        mt: 'auto',
        backgroundColor: 'primary.main',
        color: '#FFFFFF',
        borderTop: '1px solid',
        borderColor: alpha('#FFFFFF', 0.1),
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={3} alignItems="center">
          {/* Left: Primary Logo */}
          <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' } }}>
            <Box
              component="img"
              src={primaryLogo}
              alt="Bright Future Power Logo"
              sx={{
                height: 45,
                width: 'auto',
              }}
            />
          </Grid>

          {/* Middle: Tagline */}
          <Grid item xs={12} md={4} sx={{ textAlign: 'center' }}>
            <Typography variant="body2" color={alpha('#FFFFFF', 0.7)}>
              Empowering sustainable business for a greener future.
            </Typography>
          </Grid>

          {/* Right: Icon Logo with Copyright */}
          <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Box
              component="img"
              src={iconLogo}
              alt="Bright Future Power Icon"
              sx={{
                height: 65,
                width: 'auto',
                mb: 1.5,
              }}
            />
            <Typography variant="body2" color={alpha('#FFFFFF', 0.9)} align="center">
              &copy; {currentYear}{' '}
              <Link 
                sx={{ 
                  color: alpha('#FFFFFF', 0.9),
                  textDecoration: 'none',
                  fontWeight: 500,
                  '&:hover': {
                    color: theme.palette.secondary.main,
                    textDecoration: 'underline',
                  }
                }} 
                href="https://www.ecometricx.com" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Bright Future Power Initiative
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;